import axios from 'axios';
import qs from 'qs';
import md5 from 'md5';
import Local from './helper/local';
import { HelperCore } from './helper';
import EE from './event';
import globalStore from '@src/store/global';
import Conf from './conf';
import client360Store from '@public/client/client360';
import { v4 as uuidv4 } from 'uuid';
import slsLogger from '@public/log/sls';
import { isEnableEnterpriseKbPage, isNoRewriteApi } from '@/components/kb-node-tree/utils'

/**
 * 测试环境 character1 .env.production develop 分支
 * 回归环境 .env.online online 分支
 * 线上环境 .env.master master 分支
 */
const isNami = /NAMIAI/i.test(navigator.userAgent)
const baseURL = import.meta.env.VITE_API_URL;
// 配后端数据的接收方式application/json;charset=UTF-8 或 application/x-www-form-urlencoded;charset=UTF-8
const contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
// 最长请求时间
const requestTimeout = 60000;
// 协议成功状态码
const successCode = [200, '200', 0];
// 返回数据状态key
const statusName = 'code';
// 拿到Auth-Token后再放到header里再传给接口
let authToken = '';

export const getHeaders = () => {
  //zm-token = MD5(device-platform + timestamp + zm-ver + access-token + md(zm-ua))
  let requestHeaderArr = [
    'Web',
    HelperCore.getISO8601Time(),
    '1.2',
    HelperCore.getMid(),
    md5(navigator.userAgent),
  ];
  // 公共参数定义，统一放在 Request Header
  let requestHeaderData = {
    'device-platform': requestHeaderArr[0],
    timestamp: requestHeaderArr[1],
    'zm-ver': requestHeaderArr[2],
    'access-token': requestHeaderArr[3],
    'zm-token': '',
    'zm-ua': requestHeaderArr[4]
  };
  //如果 access_token 为空，则不参与 zm-token 计算
  if (!requestHeaderArr[3]) {
    requestHeaderArr.splice(3, 1);
  }

  requestHeaderData['nami-platform'] = HelperCore.getOsInfo()?.name;
  try {
    if (isNami ){
      requestHeaderData['nami-version'] = window.external.GetVersion(window.external.GetSID(window))
    }
  } catch(e) {
    console.log('获取失败')
  }


  requestHeaderData['zm-token'] = md5(requestHeaderArr.join(''));
  return {
    ...requestHeaderData,
    'func-ver': 1, //新版本接口标识
    'Content-Type': contentType,
    'mid': client360Store.mid,
    'sid': client360Store.sid,
    'Auth-Token': authToken,
    'Request-Id': uuidv4(),
  };
};

const service = axios.create({
  baseURL,
  headers: {
    'Content-Type': contentType,
  },
  timeout: requestTimeout,
  withCredentials: true, // 默认携带 cookie，如 ajax 请求第三方接口/CDN，请注意指定 withCredentials false
});

const handleResponse = function (response) {
  const { data, status, config, headers = {} } = response;
  const _authToken = headers['auth-token'] || headers['Auth-Token'] || '';
  const xid = headers['x-id'] || headers['X-Id'];
  if(xid){
    HelperCore.log(`update x-id`, xid, headers['x-id'], headers['X-Id']);
    globalStore.setUserConfig({
      xid,
    });
  }
  if (_authToken) {
    authToken = _authToken;
  }
  let code = data && data[statusName] ? data[statusName] : status;

  if (data && successCode.indexOf(data[statusName]) > -1) {
    code = 200;
  }

  // 服务端返回错误数据
  if (data == null) {
    console.warn('response-error', response.request?.responseURL);
  }

  switch (code) {
    case 200:
      return Promise.resolve(data);
    case 4001:
    case 401:
    case 403:
      // 静态资源等 head 请求，不要触发退出登录
      if (config && config.method == 'head') {
      } else {
        EE.emit('logout', {
          from: code,
          response,
        });
      }
      break;
    case 502:
      //接口请求超时异常情况
      const msg = '请求超时';
      slsLogger.log({
        action : "request",
        ext : code,
        ext1 : msg,
        ext2 : "request_js",
        ext3 : response.request?.responseURL || response.url || config?.url || "",
      });
      return Promise.reject({code, msg});
  }

  if(
    ![
      4001,   // 未登录
    ].includes(code)
    && !config?.notReport
  ){
    slsLogger.log({
      action : "request",
      ext : code,
      ext1 : JSON.stringify(data),
      ext2 : config?.data ? JSON.stringify(config.data) : "request_js",
      ext3 : response.request?.responseURL || response.url || config?.url || "",
    });
  }

  return Promise.reject(data || globalStore.errorList.noResponse);
};

//API Request 格式:Form Data
service.interceptors.request.use(
  request => {
    // 添加多语言通用参数
    const localLang = Local.getItem('LOCAL_LANG');
    if (isEnableEnterpriseKbPage() && !request.url.startsWith('http') && !isNoRewriteApi(request.url)) {
      request.url = `${import.meta.env.VITE_SAFE_HOST}/api${request.url}`
    }
    if (localLang) {
      if (request.method == 'get') {
        if (request.params.timeout) {
          request.timeout = request.params.timeout
          delete request.params.timeout
        }
        request.params = {hl: localLang, ...request.params};
      }

      // post 处理
      if (request.method == 'post' && request.data) {
        if (request.dataIsForm) {
          if (!request.data.has('hl')) {
            request.data.append('hl', localLang);
          }
        } else {
          if (!request.data['hl']) {
            request.data['hl'] = localLang;
          }
        }
      }
    }

    request.headers = getHeaders();
    if (request.method == 'post' && request.data) {
      // 如果用 json 提交较复杂的参数
      if (request.dataIsJson) {
        request.headers['Content-Type'] = 'application/json';
      }
      // 如果请求中包含 file，自行构建 formData 后设置 options.dataIsForm = true
      else if (!request.dataIsForm) {
        request.data = qs.stringify(request.data, { arrayFormat: 'brackets' });
      }
    }

    return request;
  },
  error => {
    return Promise.reject(globalStore.errorList.noResponse);
  }
);

service.interceptors.response.use(
  response => {
    // 二进制数据
    if (response.headers['content-type'] == 'application/octet-stream') {
      return response;
    }

    return handleResponse(response);
  },
  error => {
    const { response, message } = error;
    if (axios.isCancel(error)) {
      return new Promise(() => { });
    } else if (response === undefined) {
      if (message && message.includes) {
        if (message.includes('timeout')) {
          slsLogger.log({
            action : "request",
            arrt : "noresponse",
            ext : "timeout",
            ext1 : message,
            ext2 : JSON.stringify({
              url : error.config?.url || "",
              data : error.config?.data || {},
            }),
            ext3 : error.config?.url || "",
          });

          return Promise.reject({
            ...globalStore.errorList.timeout,
            ...{
              error: {
                code: error.code,
                name: error.name,
                message: error.message,
              },
            }
          });
        }
      }

      slsLogger.log({
        action : "request",
        arrt : "noresponse",
        ext : "0",
        ext1 : message || "",
        ext2 : JSON.stringify({
          url : error.config?.url || "",
          data : error.config?.data || {},
        }),
        ext3 : error.config?.url || "",
      });

      return Promise.reject(error);
    } else {
      return handleResponse(response);
    }
  }
);

export const fetchWithKeepAlive = (url, data) => {
  const body = qs.stringify(data, { arrayFormat: 'brackets' });

  return fetch(`${baseURL}${url}`, {
    credentials: 'include',
    method: 'POST',
    headers: getHeaders(),
    body,
    keepalive: true,
  });
};

// 获取资源 arraybuffer
export const fetchArrayBufferByUrl = async (url) => {
  const res = await axios.get(url, { responseType: "arraybuffer" });
  return res.data;
};

// 获取资源文本
export const fetchTextByUrl = (url) => {
  return axios.get(url, { responseType: "text" });
};

// 关键日志，报给推推机器人
export const reportToNRobot = (message) => {
  if(typeof message != "string"){
    message = JSON.stringify(message);
  }

  if(globalStore.globalConfig.closeReportToNRobot){
    console.error(`reportToNRobot 已经关闭上报`, message);
    return;
  }

  if(!HelperCore.IS_PROD){
    console.error(`reportToNRobot`, message);
  }

  return service.post("/robot/message/custom/send", {
    msgtype : "text",
    togroups : [
      "7652669648950828", // 卫士前端告警
    ],
    text : {
      content : message,
    },
  }, {
    dataIsJson : true,
  })
  .catch(res => res);
}
export const reportToNRobotWithBasicInfo = (message) => {
  if(typeof message != "string"){
    message = JSON.stringify(message);
  }

  message = [
    Conf.appName,
    `route: ${location.href}`,
    `ua: ${navigator.userAgent}`,
    `message: ${message}`,
  ].join("\n");

  reportToNRobot(message);
}

// 容错，处理多个 chunk 一起返回的情况
const getStreamContentList = content => {
  if(/\n/.test(content)){
    let res = [];
    const list = content.split(/\n/);
    list.map((piece, index) => {
      if(!piece){
        return;
      }
      res = [...res, ...getStreamContentList(piece)];
    });
    return res;
  }

  try{
    const res = JSON.parse(content);
    return [res];
  } catch(e){
    return ;
  }
}
// 接收机器人回复 stream
export const XHRStreamHandler = (url, data, callback = () => {}) => {
  let resolvedCharLength = 0;
  HelperCore.log(`stream begin`);
  return service.post(url, data, {
    // debug
    timeout : 1000000,
    // timeout : 1000,
    onDownloadProgress : (res) => {
      const xhr = res.target;

      try{
        const content = xhr.response.substr(resolvedCharLength);
        HelperCore.log(`stream content:`, content);
        const resList = getStreamContentList(content);
        resList.forEach(res => {
          // 数据有效性校验
          if(!res){
            return;
          }
          if(["msg_id", "reply"].some(key => !res[key])){
            return;
          }

          callback(res);
        });
      } catch(e){}
      resolvedCharLength = xhr.responseText.length;
    },
  });
}

export default service;

